module.exports = __webpack_public_path__ + "img/home_header.eec19624.webp";